export class SearchModel {
    term: string;
    page: number;
}
